// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Irrigation Activity Indicator Styles */

.irrigation-activity-indicator {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
  min-width: 150px;
}

.irrigation-activity-indicator--empty {
  padding: 8px 12px;
  display: flex;
  align-items: center;
}

.irrigation-activity-indicator__status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.irrigation-activity-indicator__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--color-status-positive-80);
  background-color: var(--color-status-positive-80);
}

.irrigation-activity-indicator__dot--blinking {
  animation: blink-animation 2s infinite;
}

@keyframes blink-animation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.irrigation-activity-indicator__text {
  color: var(--color-status-positive-80);
  color: var(--color-status-positive-80);
}

.irrigation-activity-indicator__time {
  display: flex;
  align-items: center;
}

.irrigation-activity-indicator__source {
  display: flex;
  align-items: center;
  margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/IrrigationActivityIndicator.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* Irrigation Activity Indicator Styles */\n\n.irrigation-activity-indicator {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 12px;\n  min-width: 150px;\n}\n\n.irrigation-activity-indicator--empty {\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n}\n\n.irrigation-activity-indicator__status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.irrigation-activity-indicator__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--color-status-positive-80);\n  background-color: var(--color-status-positive-80);\n}\n\n.irrigation-activity-indicator__dot--blinking {\n  animation: blink-animation 2s infinite;\n}\n\n@keyframes blink-animation {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.irrigation-activity-indicator__text {\n  color: var(--color-status-positive-80);\n  color: var(--color-status-positive-80);\n}\n\n.irrigation-activity-indicator__time {\n  display: flex;\n  align-items: center;\n}\n\n.irrigation-activity-indicator__source {\n  display: flex;\n  align-items: center;\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
